import { call, put, select } from 'redux-saga/effects';
import {
  apiPortfoliosHoldingsGet,
  apiPortfoliosPerformanceGet,
  apiPortfoliosDetailsGet,
  apiPortfoliosKpisGet,
} from '../api/portfolio';
import {
  PORTFOLIOS_BENCHMARK_GET,
  PORTFOLIOS_HOLDINGS_GET,
  PORTFOLIOS_DETAILS_GET,
  PORTFOLIOS_KPIS_GET,
} from '../actions/types';
import { createQadraSaga } from './shared';

function* accountPortfoliosBenchmarkGet({
  payload: { portfolioId, benchmarkId, yearsTag, compareIds },
}) {
  const accountId = yield select((s) => s.accounts.accountId);

  const { chart } = yield call(apiPortfoliosPerformanceGet, portfolioId, {
    benchmarkId,
    yearsTag,
    compareIds,
  });
  yield put({
    type: PORTFOLIOS_BENCHMARK_GET._SUCCESS,
    payload: {
      accountId,
      portfolioId,
      performanceChartBenchmarkId: benchmarkId,
      performanceChart: chart,
      compareIds,
      performanceChartYearsTag: yearsTag,
    },
  });
}

const watchAccountPortfoliosBenchmarkGet = createQadraSaga(accountPortfoliosBenchmarkGet, {
  action: PORTFOLIOS_BENCHMARK_GET._REQUEST,
});

function* accountPortfoliosKpisGet({ payload: { portfolioId, yearsTag, startDate, endDate } }) {
  const { kpis } = yield call(apiPortfoliosKpisGet, portfolioId, {
    yearsTag,
    startDate,
    endDate,
  });
  yield put({
    type: PORTFOLIOS_KPIS_GET._SUCCESS,
    payload: {
      portfolioId,
      kpis,
    },
  });
}

const watchAccountPortfoliosKpisGet = createQadraSaga(accountPortfoliosKpisGet, {
  action: PORTFOLIOS_KPIS_GET._REQUEST,
});

function* accountPortfoliosHoldingsGet({ payload: { portfolioId } }) {
  const accountId = yield select((s) => s.accounts.accountId);
  const { holdings } = yield call(apiPortfoliosHoldingsGet, portfolioId);

  yield put({
    type: PORTFOLIOS_HOLDINGS_GET._SUCCESS,
    payload: { portfolioId, portfolioHoldings: holdings, accountId },
  });
}

const watchAccountPortfoliosHoldingsGet = createQadraSaga(accountPortfoliosHoldingsGet, {
  name: 'holdingsGet',
  action: PORTFOLIOS_HOLDINGS_GET._REQUEST,
});

function* accountPortfoliosDetailsGet({ payload: { portfolioId } }) {
  const accountId = yield select((s) => s.accounts.accountId);
  const { portfolio } = yield call(apiPortfoliosDetailsGet, portfolioId);

  yield put({
    type: PORTFOLIOS_DETAILS_GET._SUCCESS,
    payload: { portfolioId, portfolio, accountId },
  });
}

const watchAccountPortfoliosDetailsGet = createQadraSaga(accountPortfoliosDetailsGet, {
  action: PORTFOLIOS_DETAILS_GET._REQUEST,
});

export default [
  watchAccountPortfoliosBenchmarkGet,
  watchAccountPortfoliosKpisGet,
  watchAccountPortfoliosHoldingsGet,
  watchAccountPortfoliosDetailsGet,
];
